import { Component, Input, OnInit } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory.service';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';

@Component({
  selector: 'app-inventory-item-note',
  templateUrl: './inventory-item-note.component.html',
  styleUrls: ['./inventory-item-note.component.scss']
})
export class InventoryItemNoteComponent implements OnInit {
  public Editor = ClassicEditor;

  @Input()
  public item: InventoryItem;

  @Input()
  public data: any;

  constructor(private inventoryService: InventoryService) {}

  ngOnInit(): void {

  }

  save({ editor }: ChangeEvent) {
    const data = editor.getData();

    this.item.description = data;

    this.item.lastModified = new Date();
    this.inventoryService.updateOne(this.item).subscribe(r => { });    
  }
}
